import { render } from "./ExpendCreate.vue?vue&type=template&id=493fa0ae&scoped=true"
import script from "./ExpendCreate.vue?vue&type=script&lang=js"
export * from "./ExpendCreate.vue?vue&type=script&lang=js"

import "./ExpendCreate.vue?vue&type=style&index=0&id=493fa0ae&scoped=true&lang=less&rel=stylesheet%2Fless"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493fa0ae"]])

export default __exports__